export function hasSearchParams(url: string) {
  const questionIndex = url.indexOf('?');
  const hashIndex = url.indexOf('#');
  return questionIndex >= 0 && (hashIndex < 0 || hashIndex > questionIndex);
}

export function appendSearchParams(target: string, params: URLSearchParams) {
  const paramsToAppend = params.toString();

  if (!paramsToAppend) {
    return target;
  }

  const querySign = hasSearchParams(target) ? '&' : '?';
  const [url, hash] = target.split('#');

  return url + querySign + paramsToAppend + (hash ? `#${hash}` : '');
}

export function populateSearchParams({
  original,
  source,
  params,
}: {
  original: string;
  source: Record<string, string | string[] | undefined>;
  params: string[];
}) {
  const additionalSearchParams = new URLSearchParams();
  for (const param of params) {
    const paramValue = source[param];

    if (typeof paramValue === 'string') {
      additionalSearchParams.set(param, paramValue);
    }
  }

  return appendSearchParams(original, additionalSearchParams);
}

export function getUrlSafe(input: string, base?: string) {
  try {
    return new URL(input, base);
  } catch {
    return null;
  }
}
